import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {LogService} from "../../../../../shared/services/LogService";

@Component({
  selector: 'app-promotion-hero',
  templateUrl: './promotion-hero.component.html',
  styleUrls: ['./promotion-hero.component.scss']
})
export class PromotionHeroComponent implements OnInit {

  @Input() partnerDetails: any;
  partnerDetailContentURL: any;
  promotionHeroDataObj: any;
  promoURLObject: any = null;
  showLoading: any = true;
  @Input() isWebView;
  @Output() partnerRedeemObject: EventEmitter<any> = new EventEmitter();
  constructor(
      private rewardService: RewardService,
      private logService: LogService
  ) { }

  ngOnInit(): void {
    if (this.partnerDetails) {
      if (this.partnerDetails.contentPath) {
        this.partnerDetailContentURL = this.partnerDetails.contentPath;
        if(this.isWebView) {
          this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'hero');
        } else {
          this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'hero');
        }
        this.getPartnerDetailContentAPI();
      }
    }
  }
  getPartnerDetailContentAPI(){
    this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
      this.showLoading = false;
      this.promotionHeroDataObj = this.replaceHeroHeadingTag(promotionDetailData);
    }, error => {
        this.showLoading = false;
        if(this.isWebView) {
          this.logService.log('Web View : ERROR'+ ' : ' + JSON.stringify(error), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
        }
    })
  }

  replaceHeroHeadingTag(html: string): string{
  return html.replace(/<span class="hero-intro__heading"(.*?)>(.*?)<\/span>/gi,
   `<h1 class="hero-intro__heading" role="heading" aria-level="1" $1>$2</h1>`);
  }

  getPartnerRedeemObject(data){
    if(data){
      this.partnerRedeemObject.emit(data);

    }
  }
}
